







import Vue from "vue";

export default Vue.extend({
  props: ["src"],
  data() {
    return {
      enlargePreview: false
    };
  }
});
